<div class="tooltip display-inline-block customtooltip cursor-pointer position-relative mx-1">
  <span class="cheatSheetIcon se-icon-information_stroke info-icon no-line-height font-size-18 cursor-pointer"></span>
  <span class="tooltip-text text-left font-size-xs position-absolute px-2 py-1" [ngClass]="isFlowingOut ? 'tooltip-offset tooltip-left' : 'tooltip-right'">
    @switch (infoType) {
      @case (infoMessageTypes.AUXILIARY_AMPERE_INFO) {
        <ng-container i18n="@@app.auxiliary_ampere_info">Rated current is dependent from the Voltage</ng-container>
      }
      @case (infoMessageTypes.INS_RATED_CURRENT_RESTRICTIONS_INFO) {
        <ng-container i18n="@@app.500A_630A_INS_can_be_placed_only_in_280mm_deep_enclosure">500A or 630A INS can only be placed in 280 mm deep enclosure</ng-container>
      }
      @case (infoMessageTypes.NSXM_SHORT_CIRCUIT_RESTRICTIONS_INFO) {
        <ng-container i18n="@@app.nsxm_with_short_circuit_50kA_only_in_280_mm_deep_enclosures_placeable">NSXm with short circuit 50kA only in 280 mm deep enclosures placeable</ng-container>
      }
      @case (infoMessageTypes.NSX_SHORT_CIRCUIT_RESTRICTIONS_INFO) {
        <ng-container i18n="@@app.nsx_with_short_circuit_50kA_only_in_280_mm_deep_enclosures_placeable">NSX with short circuit 50kA only in 280 mm deep enclosures placeable</ng-container>
      }
    }
  </span>
</div>
